export default __webpack_public_path__ + "static/media/icon_4.3f7fb05d.png";